import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilService } from 'src/app/core/services/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  environment = environment;

  readonly ROLE_DISPLAY: Record<string, string> = {
    'LEA': 'School System',
    'LEA3rdParty': 'School System (3rd Party)',
    'TEAMS': 'TEAMS',
    'IHE': 'College/University',
    'LEA-PA': 'Principal Act',
    'LEA-VHD': 'Verification of Higher Degree',
    'Applicant': 'Applicant',
  };

  getRoleDisplayName(roleName: string | undefined): string {
    if (!roleName) return '';
    return this.ROLE_DISPLAY[roleName] || roleName;
  }

  compareSiteRoles(a: any, b: any): boolean {
    return a?.RoleName === b?.RoleName && a?.siteId === b?.siteId;
  }
  constructor(
    private router: Router,
    public userService: UserService,
    public authService: AuthService,
    public util: UtilService,
  ) {}

  ngOnInit(): void {}

  navigate(route:string) {
    this.router.navigate([route]);
  }

  getUser(){
    return this.userService.getUser();
  }

  logout(){
    return this.authService.logout();
  }

  login(){
    window.location.href = environment.aimURL;
  }

  homePage(){
    let isEduAgent = this.userService.isEduAgent();
    return isEduAgent ? '/edu-agent/home' : '/app';
  }

  changeRoleWiseDashboard(){
    this.userService.setSelectedSiteRole(this.userService.getSelectedSiteRole());
    let isEduAgent = this.userService.isEduAgent();
    this.router.navigate(isEduAgent ? ['/edu-agent/home'] : ['/app'])
    .then(() => {
      window.location.reload();
    });;
  }
}
